'use client'

import UniversalHeader from '@/_components/Header'
import BranchesMap from '@/_components/Map/Branches'
import { useBranchList } from '@/_service/branch.service'
import { DialogBody, DialogHeader } from '@/components/ui/dialog'
import { Button, Input, Separator, Stack, Tabs } from '@chakra-ui/react'
import { useTranslations } from 'next-intl'
import React, { useRef, useState } from 'react'
import BranchesContent from './_components/content'
import { useDispatch, useSelector } from 'react-redux'
import { IRedux, ISavedBranch } from '../../_store/types'
import { useSaveBranchData } from '../../_hooks/useSaveBranchData'
import { formatBranchData } from './_utils'
import { sessionActions } from '../../_store/session/session.slice'
import { useActiveBrand } from '../../_hooks/useActiveBrand'

const BranchesMobile = ({ onClose }: { onClose: () => void }) => {
  const { branches } = useSelector((state: IRedux) => state.common)
  const { order_type } = useSelector((state: IRedux) => state.session)
  
  const shipperId = useActiveBrand()
  const branch = branches?.[shipperId]

  const [value, setValue] = useState<string | null>('map')
  const [search, setSearch] = useState<string>('')
  const [selectedBranch, setSelectedBranch] = useState<ISavedBranch | null>(branch)

  const branchRefs = useRef<Record<string, HTMLDivElement | null>>({})

  const t = useTranslations()
  const dispatch = useDispatch()
  const saveBranch = useSaveBranchData()

  const { data } = useBranchList({
    params: { page: 1, limit: 100, search, order_type_id: order_type?.id },
    props: { enabled: true },
  })

  const onConfirm = () => {
    if (selectedBranch) {
      dispatch(sessionActions.acceptPGL())
      saveBranch(formatBranchData(selectedBranch))
      onClose()
    }
  }

  return (
    <>
      <DialogHeader p={0}>
        <UniversalHeader
          onBack={() => onClose()}
          title={t('branch_selection')}
        />
      </DialogHeader>
      <DialogBody p={0} display='flex' flexDir='column'>
        <Tabs.Root
          w='90%'
          top='52px'
          left='50%'
          zIndex={1}
          size={'lg'}
          variant='plain'
          defaultValue='map'
          position='absolute'
          transform='translateX(-45%)'
          value={value}
          onValueChange={(e: any) => setValue(e.value)}
        >
          <Tabs.List
            p='1'
            w={'90%'}
            rounded={16}
            bg='background'
            color={'text.muted'}
            textAlign={'center'}
          >
            <Tabs.Trigger
              _selected={{
                color: 'text',
              }}
              w={'full'}
              value='map'
              color={'text.muted'}
              justifyContent={'center'}
            >
              {t('map')}
            </Tabs.Trigger>
            <Tabs.Trigger
              _selected={{
                color: 'text',
                rounded: 12,
              }}
              w={'full'}
              value='list'
              color={'text.muted'}
              justifyContent={'center'}
            >
              {t('list')}
            </Tabs.Trigger>
            <Tabs.Indicator bgColor={'background.card'} rounded={12} />
          </Tabs.List>
        </Tabs.Root>
        {value === 'map' ? (
          <BranchesMap
            isSelected={true}
            data={data?.branches}
            onClose={() => onClose()}
          />
        ) : (
          <Stack flex={1} gap={0} mt={70} p={4} overflow='hidden' color='text'>
            <Input
              _focus={{
                outline: 'primary',
                borderColor: 'primary',
              }}
              _active={{
                outline: 'primary',
                borderColor: 'primary',
              }}
              size='xl'
              rounded={16}
              h={'56px'}
              name='search'
              autoCorrect='off'
              autoComplete='off'
              value={search}
              color={'text'}
              _placeholder={{
                color: 'text',
              }}
              border={'1px solid gray.100'}
              onChange={(e) => setSearch(e.target.value)}
              placeholder={t('search')}
            />
            <Separator my={4} borderColor='var(--bg-default)' />
            <BranchesContent
              data={data?.branches}
              branchRefs={branchRefs}
              selectedBranch={selectedBranch}
              setSelectedBranch={setSelectedBranch}
            />
          </Stack>
        )}
        {value === 'list' && (
          <Stack p={4} bgColor='background.card'>
            <Button
              width='full'
              h={'56px'}
              rounded={16}
              bg='primary'
              color='primary.text'
              _hover={{
                bg: 'primary.hover',
              }}
              onClick={onConfirm}
              disabled={!selectedBranch}
            >
              {t('select')}
            </Button>
          </Stack>
        )}
      </DialogBody>
    </>
  )
}

export default BranchesMobile
